module.exports = __WEBPACK_EXTERNAL_MODULE_96__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 96
// module chunks = 0